module.exports = __webpack_public_path__ + "static/index/img/baikal-706.e26ce73b.jpg";